module.exports = __webpack_public_path__ + "media/images/efficacy-segment-2d20876003d260b2b17795137a881734.jpg";